/** Tiny cross-view store for the admin "open access requests" badge count.
 *  Seeded from whoami on boot, then decremented live as an admin approves/denies
 *  so the nav badge (rendered by chrome.ts) reflects reality without a refresh. */
let pending = 0;

export const pendingRequests = {
  get: (): number => pending,
  set: (n: number): void => {
    pending = Math.max(0, n);
  },
};
